import axios from 'axios';
import { setupInterceptors } from './interceptor';

// Vite uses import.meta.env for environment variables
// For Jest compatibility, the babel-plugin-transform-import-meta transforms this
const BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:3000';

if (!BASE_URL) {
  throw new Error('VITE_API_BASE_URL is not defined');
}

const apiClient = axios.create({
  baseURL: BASE_URL,
  timeout: 160000,
});

setupInterceptors(apiClient);

const withAbort = requestFn => {
  const controller = new AbortController();
  const promise = requestFn(controller.signal);
  promise.abort = () => controller.abort();
  return promise;
};

export const client = {
  get: (url, config = {}) =>
    withAbort(signal => apiClient.get(url, { ...config, signal })),

  post: (url, data, config = {}) =>
    withAbort(signal => apiClient.post(url, data, { ...config, signal })),

  put: (url, data, config = {}) =>
    withAbort(signal => apiClient.put(url, data, { ...config, signal })),

  delete: (url, config = {}) =>
    withAbort(signal => apiClient.delete(url, { ...config, signal })),
};
